import React, {useState, useEffect, useCallback, useContext, useRef} from 'react';
import CommandsContext from '../../../context/commandsContext';
import MenuContext from '../../../context/menuContext';
import ValuesContext from '../../../context/valuesContext';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import NumberEntryView from '../../views/numberEntryView';
import ZeroCalibration from './zero-calibration';
import ZeroCalSave from './zero-CalSave';

function ZeroTime({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const [value, setValue] = useState(20);
  const {onUpdateCommands} = useContext(CommandsContext);
  const {values, onUpdateValues} = useContext(ValuesContext);
  const {selected, onComponent} = useContext(MenuContext);
  const inputRef = useRef();

  const onLeft = useCallback(() => {
    onComponent(<ZeroCalibration />);
  }, []);

  const onRight = useCallback(() => {
    onComponent(<ZeroCalSave onExit={() => onComponent(selected.component)} />);
  }, []);

  useEffect(() => {
    if (!leftPress) return;
    onLeft();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onRight();
  }, [rightPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands(commands => ({...commands, onLeft, onRight}));
    });
  }, [onLeft, onRight]);

  useEffect(() => {
    if (values[selected.id]) {
      inputRef.current.value = values[selected.id];
    }
  }, [values, selected]);

  useEffect(() => {}, [value]);
  return (
    <NumberEntryView
      max={20}
      inputRef={inputRef}
      caption="Enter Zero Time"
      title="Enter Zero Time"
      left="Cancel"
      right="Save"
      defaultValue={20}
    />
  );
}

export default ZeroTime;
